export const fixtures = {
  buttonCta: 'Got it',
};
